import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView } from '@/components/base'
import { StickyHeaderNavigation, SettingItem } from '@/components'
import { securityActionsList } from '@/constants/securityActions'
import useOffsets from '@/hooks/useOffsets'

export const SecurityScreen: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const offsets = useOffsets()

  const handleActionPress = (action: (typeof securityActionsList)[0]) => {
    if (action.route) {
      navigate(action.route)
      return
    }
    if (action.link) {
      window.open(action.link, '_blank')
      return
    }
    if (action.action) {
      action.action()
    }
  }

  return (
    <BaseView flex={1} bgColor="background.screen" className="h-full">
      {/* Fixed Header Navigation */}
      <StickyHeaderNavigation title={t('screens:security.title')} />

      {/* Scrollable Content */}
      <BaseView
        flex={1}
        px={12}
        style={{
          overflowY: 'auto',
          paddingTop: offsets.top + 70,
          paddingBottom: '40px',
        }}
      >
        <BaseView gap={8}>
          {securityActionsList.map((action) => {
            if (!action.visible) {
              return null
            }

            return (
              <SettingItem
                key={action.id}
                title={t(action.titleKey)}
                icon={action.icon}
                iconColor={action.iconColor}
                iconBgColor={action.iconBgColor}
                onPress={() => handleActionPress(action)}
              />
            )
          })}
        </BaseView>
      </BaseView>
    </BaseView>
  )
}

export default SecurityScreen
